var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisVerticalRoyalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8584"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#556BB8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 2.5,
    cy: 10.5,
    r: 2.5,
    fill: "#556BB8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 2.5,
    cy: 17.5,
    r: 2.5,
    fill: "#556BB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVerticalRoyalBlue);
export default __webpack_public_path__ + "static/media/ellipsis-vertical-royal-blue.8a021d4e97a1f0a3b941e66530164ee4.svg";
export { ForwardRef as ReactComponent };